import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';

export const rateListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'currencyLeftId',
    label: 'From',
  },
  {
    name: 'currencyRightId',
    label: 'To',
  },
  {
    name: 'description',
    label: 'Description',
  },
  {
    name: 'value',
    label: 'Rate',
  },
  {
    name: 'rateSourceId',
    label: 'Rate source',
  },
  {
    name: 'date',
    label: 'Date',
  },
];

export const rateListColumnsLabels = {
  currencyRightId: 'Currency to',
  rateSourceId: 'Rate source',
};

export const rateListAllColumnsLabels = {
  currencyRightId: 'Currency to',
  rateSourceId: 'Rate source',
  currencyLeftId: 'Currency from',
};

export const rateListDefaultSorter = {};

export const rateListSchema = {
  currencyRightId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  rateSourceId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  date: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const rateListAllSchema = {
  currencyRightId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  currencyLeftId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  rateSourceId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  date: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const rateListFiltersSchema = [
  {
    name: 'rateSourceId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
  {
    name: 'currencyRightId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
];

export const rateListAllFiltersSchema = [
  {
    name: 'rateSourceId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter rate source...',
  },
  {
    name: 'currencyRightId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
  {
    name: 'currencyLeftId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter country...',
  },
];
